import React from 'react';
import { Outlet } from 'react-router-dom';
import AuthenticatedHeader from '../components/AuthenticatedHeader';
import { RequireAuth } from '../contexts/RequireAuth';

type AuthenticatedLayoutProps = {
  hasMenu?: boolean | undefined;
  fullPageForm?: boolean | undefined;
};

const AuthenticatedLayout: React.FC<AuthenticatedLayoutProps> = ({
  hasMenu,
  fullPageForm
}) => {
  return (
    <RequireAuth>
      <div className="container">
        <AuthenticatedHeader />
        <div className="layout">
          <div
            className={`content ${hasMenu ? 'content-menu' : ''} ${
              fullPageForm ? 'page-form' : ''
            }`}
          >
            <Outlet />
          </div>
        </div>
      </div>
    </RequireAuth>
  );
};

export default AuthenticatedLayout;
